import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Timer, Square, ChevronDown } from "lucide-react";
import { api } from "../lib/api";

function fmt(s) {
  s = Math.max(0, Math.floor(s));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  const p = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${p(m)}:${p(sec)}` : `${p(m)}:${p(sec)}`;
}
const elapsed = (t) => (t.time_spent_seconds || 0) + (t.timer_started_at ? Math.floor((Date.now() - new Date(t.timer_started_at).getTime()) / 1000) : 0);

export default function RunningTimers() {
  const navigate = useNavigate();
  const [timers, setTimers] = useState([]);
  const [open, setOpen] = useState(false);
  const [, setTick] = useState(0);
  const ref = useRef(null);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/timers/running"); setTimers(data || []); } catch { /* ignore */ }
  }, []);

  useEffect(() => { load(); const i = setInterval(load, 5000); return () => clearInterval(i); }, [load]);
  useEffect(() => { const h = () => load(); window.addEventListener("fd-timers-changed", h); return () => window.removeEventListener("fd-timers-changed", h); }, [load]);
  useEffect(() => { const i = setInterval(() => setTick((t) => t + 1), 1000); return () => clearInterval(i); }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const stop = async (id) => { try { await api.post(`/tasks/${id}/timer/stop`); load(); } catch { /* ignore */ } };

  if (timers.length === 0) return null;
  const total = timers.reduce((a, t) => a + elapsed(t), 0);

  return (
    <div ref={ref} className="relative shrink-0" data-testid="running-timers">
      <button data-testid="running-timers-btn" onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 h-9 pl-2.5 pr-3 rounded-full bg-signal/15 border border-signal/40 text-signal hover:bg-signal/25 transition-colors">
        <span className="relative flex h-2 w-2"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-signal opacity-60" /><span className="relative inline-flex rounded-full h-2 w-2 bg-signal" /></span>
        <Timer size={15} />
        <span className="font-cabinet font-bold text-sm tabular-nums">{fmt(total)}</span>
        {timers.length > 1 && <span className="text-[11px] font-semibold bg-signal/25 rounded-full px-1.5">{timers.length}</span>}
        <ChevronDown size={13} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid="running-timers-menu" className="absolute right-0 top-full mt-2 z-40 w-80 bg-card border border-black/10 dark:border-white/10 rounded-2xl shadow-2xl p-2 animate-in fade-in">
          <p className="px-2.5 py-1.5 text-[10px] uppercase tracking-widest text-zinc-500">Chronos en cours ({timers.length})</p>
          {timers.map((t) => (
            <div key={t.id} data-testid={`running-timer-${t.id}`} className="flex items-center gap-2 px-2.5 py-2 rounded-lg hover:bg-black/[0.04] dark:hover:bg-white/[0.06] group">
              <button onClick={() => { setOpen(false); navigate("/tasks"); }} className="min-w-0 flex-1 text-left">
                <div className="text-sm font-medium truncate">{t.title}</div>
                <div className="text-[11px] text-zinc-500 truncate">{t.ref}{t.company_name ? ` · ${t.company_name}` : ""}</div>
              </button>
              <span className="font-cabinet font-bold text-sm text-signal tabular-nums shrink-0">{fmt(elapsed(t))}</span>
              <button data-testid={`stop-timer-${t.id}`} onClick={() => stop(t.id)} title="Arrêter" className="shrink-0 p-1.5 rounded-md text-zinc-400 hover:text-signal hover:bg-signal/10"><Square size={14} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
